export {
  getRootCommand,
  getLimitedRootCommand,
} from './commands/root-command.js';
